// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1sdgc","close":"style_close__1cBJp"};